import React, { useState, useEffect } from 'react';
import { Grid, FormControl, Select, MenuItem, Typography, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { PhotoLibrary, VideoLibrary } from '@mui/icons-material';
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout';
import { PermissionGuard } from '../../components/PermissionGuard';
import VideoUpload from './VideoUpload';
import VideoList from './VideoList';
import ImageUpload from './ImageUpload';
import ImageList from './ImageList';

const Media = () => {
    const menuDispatch = useDispatch();
    const [mediaType, setMediaType] = useState('video');
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'media'
        });
    }, [menuDispatch]);

    const handleMediaTypeChange = (event) => {
        setMediaType(event.target.value);
    };

    const handleUploadSuccess = () => {
        // Trigger refresh of the list
        setRefreshTrigger(prev => prev + 1);
    };

    return (
        <>
            <PageHeaderLayout headerTitle={'Media Management'}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography sx={{ fontSize: '0.85rem' }}>Media Type:</Typography>
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                        <Select
                            value={mediaType}
                            onChange={handleMediaTypeChange}
                            sx={{ fontSize: '0.75rem' }}
                        >
                            <MenuItem value="video" sx={{ fontSize: '0.75rem' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <VideoLibrary fontSize="small" />
                                    Video
                                </Box>
                            </MenuItem>
                            <MenuItem value="image" sx={{ fontSize: '0.75rem' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <PhotoLibrary fontSize="small" />
                                    Image
                                </Box>
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </PageHeaderLayout>

            <Grid container spacing={2} sx={{ mt: 1 }}>
                {/* Upload Section */}
                <Grid item xs={12} md={5}>
                    {mediaType === 'video' ? (
                        // <PermissionGuard feature="media" permission="canCreate">
                            <VideoUpload onUploadSuccess={handleUploadSuccess} />
                        // </PermissionGuard>
                    ) : (
                        // <PermissionGuard feature="media" permission="canCreate">
                            <ImageUpload onUploadSuccess={handleUploadSuccess} />
                        // </PermissionGuard>
                    )}
                </Grid>

                {/* List Section */}
                <Grid item xs={12} md={7}>
                    {/* <PermissionGuard feature="media" permission="canView"> */}
                        {mediaType === 'video' ? (
                            <VideoList refreshTrigger={refreshTrigger} />
                        ) : (
                            <ImageList refreshTrigger={refreshTrigger} />
                        )}
                    {/* </PermissionGuard> */}
                </Grid>
            </Grid>
        </>
    );
};

export default Media;
